import React from 'react'
import styles from './GoalCards.scss'
import { ProgressBar } from 'common/ProgressBar'
import { Link } from 'react-router-dom'
import * as urlHelpers from 'lib/urlHelpers'
import cx from 'classnames'

export const GenericCard = ({ title, text, img, link, href, progress, rank, actionLink, highlight = false, className, children }) => {
  return (
    <div className={cx(styles.GoalParticipantCard, highlight && styles.highlight, className)}>
      <div className={styles.flexContainer}>
        <div className={styles.goalIconWrap}>
          <img src={img} className={styles.goalIcon} />
        </div>
        <div className={styles.middle}>
          {link && <Link to={link}><h3 className={styles.goalName}>{title}</h3></Link>}
          {href && <a href={href}><h3 className={styles.goalName}>{title}</h3></a>}
          {!link && !href && <h3 className={styles.goalName}>{title}</h3>}
          <div className={styles.cardText}>{text}</div>
        </div>
        {actionLink && <div className={styles.actionLink}>{actionLink}</div>}
        {rank && <div className={styles.rank}>#{rank}</div>}
      </div>
      {(progress === 0 || progress) && <div className={styles.progress}>
        <ProgressBar progress={progress} height='5px' />
      </div>}
      {children && <div className={styles.children}>{children}</div>}
    </div>
  )
}

// Card focusing on the user participating in a goal (i.e. for a leaderboard)
export const ParticipantCard = ({ goalParticipant, goal, includeRank = true, highlight, ...props }) => {
  const user = goalParticipant.get('user')
  const title = user.get('name')
  const img = urlHelpers.photoCenti(user.get('highlighted_photo_id'))
  const progress = goalParticipant.getIn(['goal_params', 'percent'])
  const href = `/users/${user.get('id')}`
  const trailer = goalParticipant.getIn(['goal_params', 'trailer'])
  // TODO make the server drive this text
  const text = Math.floor(progress * 100) + '% complete' + (trailer ? (' ∙ ' + trailer) : '')
  const rank = includeRank && goalParticipant.get('rank')
  return GenericCard({ title, text, img, href, progress, rank, highlight, ...props })
}

// Card focusing on a goal, optionally showing a goalParticipant's progress
export const GoalCard = ({ goalParticipant, goal, includeRank = true, ...props }) => {
  const title = goal.get('name')
  const img = goal.get('icon_small')
  const progress = goalParticipant.getIn(['goal_params', 'percent'])
  const link = `/goals/${goal.get('id')}`
  const trailer = goalParticipant.getIn(['goal_params', 'trailer'])
  const text = Math.floor(progress * 100) + '% complete' + (trailer ? (' ∙ ' + trailer) : '')
  const rank = includeRank && goalParticipant.get('rank')
  return GenericCard({ title, text, img, link, progress, rank, ...props })
}
